import {
  GET_PROMOTION,
  GET_PROMOTION_SUCCESS,
  GET_PROMOTION_FAILURE,
  PromotionState,
} from './types'

const initialState: PromotionState = {
  promotion: null,
  isFetching: false,
  hasFetched: false,
  errorMessage: null,
}

const promotionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PROMOTION:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case GET_PROMOTION_SUCCESS: {
      const {
        payload: { promotion },
      } = action
      return {
        ...state,
        promotion,
        isFetching: false,
        hasFetched: true,
        errorMessage: null,
      }
    }
    case GET_PROMOTION_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.errorMessage,
      }
    default:
      return state
  }
}

export { initialState, promotionReducer }
